import { render, staticRenderFns } from "./GraficoMedicamento.vue?vue&type=template&id=7f530da7"
import script from "./GraficoMedicamento.vue?vue&type=script&lang=js"
export * from "./GraficoMedicamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports